import { Expander, ExpanderContent, ExpanderHeader, ResponsiveTableRow, H5 } from '@fs/zion-ui'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { DmcResponsiveTable } from '../../common/DmcResponsiveTable'
import useArtifactTopicTags from '../../../hooks/artifacts/useArtifactTopicTags'
import DeleteTopicTagButton from '../button/DeleteTopicTagButton'

/**
 * Displays information about the artifact’s  3232, and provides
 * a link to the comments in the Sources and Discussions Admin tool.
 */
export default function TopicTagsPanel({ artifactId }) {
  const [t] = useTranslation()
  const title = t('artifacts.topicTags', 'Topic Tags')
  const { topicTags, refetch } = useArtifactTopicTags(artifactId)
  const columnHeaders = [t('name', 'Name'), t('id', 'ID'), '']

  if (!topicTags || !topicTags.topic || topicTags.topic.length === 0) {
    return null
  }

  let tableRows = []
  tableRows = topicTags.topic.map((topicTag) => {
    return (
      <ResponsiveTableRow
        key={topicTag.id}
        column1={topicTag.name}
        column2={topicTag.id}
        column3={<DeleteTopicTagButton topicTag={topicTag.name} topicTagId={topicTag.id} refetch={refetch} />}
      />
    )
  })

  return (
    <Expander>
      <ExpanderHeader>
        <H5>{`${title} (${topicTags.topic.length})`}</H5>
      </ExpanderHeader>
      <ExpanderContent>
        <DmcResponsiveTable
          totalColumnCount={columnHeaders.length}
          atSizeColumns={{
            default: {
              labels: columnHeaders,
            },
          }}
          separator={<br />}
        >
          {tableRows}
        </DmcResponsiveTable>
      </ExpanderContent>
    </Expander>
  )
}
